import { render } from "./collapse.vue?vue&type=template&id=d63fcd2a&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=d63fcd2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d63fcd2a"

export default script